import React from 'react'
import LinkItem from 'components/Link'
import StatusPill from './StatusPill'

export default function MiniTable({ columns, rows = [], statusKey = 'status', moreCount = 0, moreUrl, moreLabel, emptyTitle, emptyHint }) {
  return (
    <div className="w-full border border-border-lines rounded-xl overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-dark-blue bg-background">
              {
                columns.map((col) => (
                  <th key={col.key} className="py-2.5 px-4 font-semibold uppercase text-sm tracking-wide whitespace-nowrap">
                    {col.label}
                  </th>
                ))
              }
            </tr>
          </thead>

          <tbody>
            {
              rows.length ? rows.map((row, index) => (
                <tr key={row.id ?? index} className="border-t border-border-lines">
                  {
                    columns.map((col) => (
                      <td key={col.key} className="py-4 px-4 text-dark-blue whitespace-nowrap">
                        {
                          col.key === statusKey
                            ? <StatusPill active={row[col.key] === 'active'} />
                            : row[col.key]
                        }
                      </td>
                    ))
                  }
                </tr>
              )) : (
                <tr>
                  <td colSpan={columns.length} className="text-center py-10">
                    <p className="font-bold text-dark-blue">{emptyTitle}</p>
                    {emptyHint && <p className="text-sm text-secondary mt-1">{emptyHint}</p>}
                  </td>
                </tr>
              )
            }
          </tbody>
        </table>
      </div>

      {
        moreCount > 0 && (
          <div className="px-4 py-3 border-t border-border-lines">
            <LinkItem
              url={moreUrl}
              classList="inline-block text-primary text-sm font-medium"
              tag={() => <>+{moreCount} {moreLabel}</>}
            />
          </div>
        )
      }
    </div>
  )
}
